module.exports = __webpack_public_path__ + "img/calculatorBg.de91170.png";